import React from "react";

type Props = {
  text: string,
};

const TextFormatter = ({ text }: Props) => {
  return (
    <>
      {text.split("(").map((st, index) =>
        st.indexOf("]") > 0 ? (
          <React.Fragment key={index}>
            <a href={st.split("]")[0].split(")[")[1]}>
              {st.split("]")[0].split(")[")[0]}
            </a>
            <>{st.split("]")[1]}</>
          </React.Fragment>
        ) : (
          <React.Fragment key={index}>{st}</React.Fragment>
        )
      )}
    </>
  );
};

export default TextFormatter;
